// ** React Imports
import { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';

import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
// ** Redux Imports
import { Provider } from 'react-redux';
import { store } from './redux/storeConfig/store';

// ** Toast & ThemeColors Context
import { toast, ToastContainer } from 'react-toastify';
import { ThemeContext } from './utility/context/ThemeColors';
import { IntlProviderWrapper } from './utility/context/Internationalization';

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner';

// ** Ripple Button
import './@core/components/ripple-button';

// ** PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-jsx.min';

import 'react-perfect-scrollbar/dist/css/styles.css';

import '@styles/react/libs/toastify/toastify.scss';

import './@core/assets/fonts/feather/iconfont.css';
import './@core/scss/core.scss';
import './assets/scss/style-rtl.scss';
import './assets/scss/variables/colorsPackage.scss';
import './assets/scss/variables/iconSaxColors.scss';

import * as serviceWorker from './serviceWorker';

const LazyApp = lazy(() => import('./App'));

// Sentry.init({
//   dsn: 'https://2b5482bb2a5d4692aa51c5bcfc04ae96@sentry.irandargah.com/4',
//   integrations: [new Integrations.BrowserTracing()],
//   tracesSampleRate: 1.0,
//   beforeSend: (event) => {
//     if (window.location.hostname === 'localhost') {
//       return null;
//     }
//     return event;
//   },
// });

if (process.env.NODE_ENV !== 'development') {
  console.log = () => {};
}

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <ThemeContext>
        <IntlProviderWrapper>
          <LazyApp />
          <ToastContainer limit={3} newestOnTop />
        </IntlProviderWrapper>
      </ThemeContext>
    </Suspense>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
